const validPositiveNumber = /^[+]?([0-9]+(?:[.][0-9]*)?|\.[0-9]+)$/;
const valiPositive = (rfc: string): boolean => validPositiveNumber.test(rfc);
export default valiPositive;
